import "@fpsm/cxy-tokens/tokens.css?__remix_sideEffect__";

import { type NavV2Response } from '~/interfaces/HeaderFooterNavV2';

import HeaderDesktop from './components/HeaderDesktop';
import HeaderMobile from './components/HeaderMobile';

interface HeaderV2Props {
  navData: NavV2Response;
  resourcesUrl: string;
}

type THeaderV2 = React.FunctionComponent<HeaderV2Props>;

export const HeaderV2: THeaderV2 = ({ navData, resourcesUrl }) => {
  const { firstLevelNav, mobileHamburgerNav, secondLevelNav, thirdLevelNav } =
  navData;

  const desktopNavData = {
    firstLevelNav,
    secondLevelNav,
    thirdLevelNav
  };

  return (
    <>
			<HeaderMobile mobileNavData={mobileHamburgerNav} />
			<HeaderDesktop
        desktopNavData={desktopNavData}
        resourcesUrl={resourcesUrl} />

		</>);

};